"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target, mod));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  APIDomainNames: () => APIDomainNames,
  AfEvents: () => AfEvents,
  App: () => App,
  AppEventPath: () => AppEventPath,
  DeviceType: () => DeviceType,
  DownstreamSystems: () => DownstreamSystems,
  ErrorTypes: () => ErrorTypes,
  EventOwnedBy: () => EventOwnedBy,
  EventTrackingPaths: () => EventTrackingPaths,
  OS: () => OS,
  Platform: () => Platform,
  default: () => IsEvents,
  eventDescriptions: () => eventDescriptions,
  eventNameMap: () => eventNameMap,
  metaPropertiesDescriptions: () => metaPropertiesDescriptions,
  oldEventNameMap: () => oldEventNameMap
});
module.exports = __toCommonJS(src_exports);

// src/util/helpers.ts
var import_is_errors = require("@invoice-simple/is-errors");
var mkBaseUrl = (environmentType) => {
  switch (environmentType) {
    case "production":
      return "https://events.getinvoicesimple.com";
    case "staging":
      return "https://events.staging.getinvoicesimple.com";
    case "development":
      return "https://events.staging.getinvoicesimple.com";
    case "sandbox":
      return "https://events.sandbox.getinvoicesimple.com";
    default:
      throw new import_is_errors.InvalidArgumentError(`Environment type '${environmentType}' is invalid`);
  }
};

// src/event-bridge.ts
var import_axios = __toESM(require("axios"));

// src/util/environment.ts
var AfEvents = /* @__PURE__ */ ((AfEvents2) => {
  AfEvents2["achievementUnlocked"] = "af_achievement_unlocked";
  AfEvents2["invoiceComplete"] = "is_invoice_complete";
  AfEvents2["invoiceComplete2"] = "is_invoice_complete2";
  AfEvents2["landingPageOpened"] = "af_paypal_landingPage_opened";
  AfEvents2["levelAchieved"] = "af_level_achieved";
  AfEvents2["merchantCreated"] = "af_paypal_merchant_created";
  AfEvents2["merchantStartedAccepting"] = "af_paypal_merchant_startedAccepting";
  AfEvents2["merchantStartedOnboarding"] = "af_paypal_merchant_startedOnboarding";
  AfEvents2["paypalOrderCaptureSuccess"] = "af_paypal-order-captureSuccess";
  AfEvents2["purchase"] = "af_purchase";
  AfEvents2["startTrial"] = "af_start_trial";
  AfEvents2["stripeOrderCaptureSuccess"] = "af_stripe-order-captureSuccess";
  AfEvents2["tutorialCompletion"] = "af_tutorial_completion";
  return AfEvents2;
})(AfEvents || {});
var EventTrackingPaths = /* @__PURE__ */ ((EventTrackingPaths2) => {
  EventTrackingPaths2["eventBus"] = "/eventBus";
  return EventTrackingPaths2;
})(EventTrackingPaths || {});
var DeviceType = /* @__PURE__ */ ((DeviceType2) => {
  DeviceType2["desktop"] = "desktop";
  DeviceType2["mobile"] = "mobile";
  DeviceType2["tablet"] = "tablet";
  return DeviceType2;
})(DeviceType || {});
var OS = /* @__PURE__ */ ((OS2) => {
  OS2["android"] = "android";
  OS2["iOS"] = "iOS";
  OS2["linux"] = "linux";
  OS2["osx"] = "osx";
  OS2["windows"] = "windows";
  return OS2;
})(OS || {});
var Platform = /* @__PURE__ */ ((Platform2) => {
  Platform2["android"] = "android";
  Platform2["ios"] = "ios";
  Platform2["server"] = "server";
  Platform2["web"] = "web";
  return Platform2;
})(Platform || {});
var App = /* @__PURE__ */ ((App2) => {
  App2["isAndroid"] = "com.aadhk.woinvoice";
  App2["isAndroidContractor"] = "com.invoicesimple.contractor.android";
  App2["isAndroidLite"] = "com.invoicesimple.lite.android";
  App2["isApi"] = "api.getinvoicesimple.com";
  App2["isApiStaging"] = "api.staging.getinvoicesimple.com";
  App2["isFinancingWebhook"] = "financing-webhook.invoicesimple.com";
  App2["isFinancingWebhookStaging"] = "financing-webhook.staging.invoicesimple.com";
  App2["isIOS"] = "com.logicalengine.qsei";
  App2["isIOSContractor"] = "com.invoicesimple.contractor.ios";
  App2["isIOSLite"] = "com.invoicesimple.lite.ios";
  App2["isPayPal"] = "paypal.invoicesimple.com";
  App2["isPayPalStaging"] = "paypal-staging.invoicesimple.com";
  App2["isServices"] = "services.getinvoicesimple.com";
  App2["isServicesStaging"] = "services.staging.getinvoicesimple.com";
  App2["isStripe"] = "stripe.invoicesimple.com";
  App2["isStripeStaging"] = "stripe.staging.invoicesimple.com";
  App2["isUnifiedXp"] = "unifiedxp.invoicesimple.com";
  App2["isUnifiedXpStaging"] = "unifiedxp.staging.invoicesimple.com";
  App2["isWeb"] = "app.invoicesimple.com";
  App2["isWebStaging"] = "app.staging.invoicesimple.com";
  return App2;
})(App || {});
var AppEventPath = /* @__PURE__ */ ((AppEventPath2) => {
  AppEventPath2["event"] = "event";
  AppEventPath2["eventAll"] = "event-all";
  return AppEventPath2;
})(AppEventPath || {});
var DownstreamSystems = /* @__PURE__ */ ((DownstreamSystems2) => {
  DownstreamSystems2["amplitude"] = "Amplitude";
  DownstreamSystems2["appsflyer"] = "Appsflyer";
  DownstreamSystems2["braze"] = "Braze";
  DownstreamSystems2["fiveTran"] = "FiveTran";
  return DownstreamSystems2;
})(DownstreamSystems || {});
var APIDomainNames = /* @__PURE__ */ ((APIDomainNames2) => {
  APIDomainNames2["production"] = "api.getinvoicesimple.com";
  APIDomainNames2["sandbox"] = "api.sandbox.getinvoicesimple.com";
  APIDomainNames2["staging"] = "api.staging.getinvoicesimple.com";
  return APIDomainNames2;
})(APIDomainNames || {});
var oldEventNameMap = {
  ["invoice-complete"]: "af_achievement_unlocked" /* achievementUnlocked */,
  ["invoice-complete2"]: "af_level_achieved" /* levelAchieved */
};
var eventNameMap = {
  ["invoice-complete"]: "is_invoice_complete" /* invoiceComplete */,
  ["invoice-complete2"]: "is_invoice_complete2" /* invoiceComplete2 */,
  ["onboarding-finish"]: "af_tutorial_completion" /* tutorialCompletion */,
  ["paypal-landingPage-opened"]: "af_paypal_landingPage_opened" /* landingPageOpened */,
  ["paypal-merchant-created"]: "af_paypal_merchant_created" /* merchantCreated */,
  ["paypal-merchant-startedAccepting"]: "af_paypal_merchant_startedAccepting" /* merchantStartedAccepting */,
  ["paypal-merchant-startedOnboarding"]: "af_paypal_merchant_startedOnboarding" /* merchantStartedOnboarding */,
  ["paypal-order-captureSuccess"]: "af_paypal-order-captureSuccess" /* paypalOrderCaptureSuccess */,
  ["stripe-order-captureSuccess"]: "af_stripe-order-captureSuccess" /* stripeOrderCaptureSuccess */,
  ["subscription-purchase"]: "af_purchase" /* purchase */
};

// src/event-bridge.ts
var import_is_errors2 = require("@invoice-simple/is-errors");
var EventBridge = class {
  constructor(baseUrl) {
    this.baseUrl = baseUrl;
  }
  async sendToBus(visitor, event) {
    var _a, _b;
    const payload = { event, visitor };
    const eventUrl = this.baseUrl + "/eventBus" /* eventBus */;
    try {
      await import_axios.default.post(eventUrl, payload);
      console.log(`Event sent to bus: ${payload.event.name}`);
    } catch (e) {
      if (import_axios.default.isAxiosError(e)) {
        const err = new import_is_errors2.RequestFailedError(`${(_a = e.response) == null ? void 0 : _a.status} - Failed to send event ${payload.event.name} to bus: ${JSON.stringify((_b = e.response) == null ? void 0 : _b.data)}`);
        console.log(err.message);
        throw err;
      }
      throw e;
    }
  }
};

// src/index.ts
var import_uuid = require("uuid");

// src/events/event-types/types.ts
var EventOwnedBy = /* @__PURE__ */ ((EventOwnedBy2) => {
  EventOwnedBy2["Core"] = "Core Team";
  EventOwnedBy2["Growth"] = "Growth Team";
  EventOwnedBy2["PaymentsCore"] = "Payments Core Team";
  EventOwnedBy2["PaymentsGrowth"] = "Payments Growth Team";
  EventOwnedBy2["Unassigned"] = "Unassigned";
  return EventOwnedBy2;
})(EventOwnedBy || {});
var ErrorTypes = [
  "abtest",
  "app-rate",
  "backup",
  "client",
  "dump",
  "email",
  "email-invoice",
  "firebase",
  "intercom",
  "localization",
  "login-failed",
  "logout-failed",
  "migration",
  "network",
  "paywall",
  "photo",
  "preview",
  "purchases",
  "push-notification",
  "realm",
  "reports",
  "share",
  "startup",
  "stripe-online",
  "subscription-purchase",
  "subscription-reactivation",
  "sync",
  "unhandled-rejection",
  "welcome-back",
  "veryfi-lens"
];

// src/events/event-types/descriptions/braze-custom-event-descriptions.ts
var brazeCustomEventDescriptions = {
  "advocate-friend-cancel": {
    description: "Tracks when a friend cancels subscription",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "advocate-friend-purchase": {
    description: "Tracks when a friend makes a purchase",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "advocate-link-share": {
    description: "Tracks when advocate shares their referral link",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "advocate-reward-limit": {
    description: "Tracks when advocate reward is rejected",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "advocate-terms-accept": {
    description: "Tracks when advocate accepts Referral Program terms and conditions",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "free-saas-modal-continue": {
    description: "Tracks when user clicking on continue on consent modal",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "mark-invoice-paid": {
    description: "Tracks when user  marks invoice as paid",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "referral-onboarding-complete": {
    description: "Tracks successful referral signup",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "referral-onboarding-emailSubmit": {
    description: "Tracks when user submits email on referral landing page",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "referral-onboarding-start": {
    description: "Tracks referral landing page visit",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "scheduled-payment-added": {
    description: "Tracks when user adds a scheduled payment",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "scheduled-payment-deleted": {
    description: "Tracks when user  deletes a scheduled payment",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  }
};

// src/events/event-types/descriptions/payments-event-description.ts
var paymentsMultiPlatformEventDescriptions = {
  "acorn-toggle-financing-settings": {
    description: "Tracks when the user performs actions on acorn toggle CTAs on web / mobile",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "payments-cta": {
    description: "Tracks when the user performs actions on payments CTAs on web / mobile",
    ownedBy: ["Payments Growth Team" /* PaymentsGrowth */]
  },
  "payments-landing-page": {
    description: "Tracks when user requests the payments landing page",
    ownedBy: ["Payments Growth Team" /* PaymentsGrowth */]
  },
  "payments-viewed": {
    description: "Tracks when views are shown after user performs actions on payments CTAs on web / mobile",
    ownedBy: ["Payments Growth Team" /* PaymentsGrowth */]
  }
};
var paymentsWebEventDescriptions = {
  "client-online-payments-request-initialSetup": {
    description: "Tracks when the user clicks on payment intent cta on email",
    ownedBy: ["Payments Growth Team" /* PaymentsGrowth */]
  }
};
var paymentsSeverEventDescriptions = {
  checkout: {
    description: "Tracks when a user performs a checkout action on checkout Page",
    ownedBy: ["Payments Growth Team" /* PaymentsGrowth */]
  },
  "financing-webhook": {
    description: "Tracks webhook events from finance-webhook",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "payments-onboardingStatus": {
    description: "Tracks when a user's onboarding status is changed",
    ownedBy: ["Payments Growth Team" /* PaymentsGrowth */]
  },
  "stripe-order-captureSuccess": {
    description: "[Checkout] Indicates when a Stripe transaction succeeds.",
    ownedBy: ["Payments Growth Team" /* PaymentsGrowth */]
  }
};

// src/events/event-types/descriptions/multi-platform-events-descriptions.ts
var multiPlatformEventDescriptions = {
  ...paymentsMultiPlatformEventDescriptions,
  "account-source": {
    description: "Tracks the source of the account when the user comes from one of our vendors link",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "advocate-action": {
    description: "Tracks advocate action related to the Refer & Earn setting",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "app-rate": {
    description: "Tracks on web / mobile what the user rates the app out of 5",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "app-rate-show": {
    description: "Tracks on web / mobile when the app rating pop up appears, ignored on Amplitude",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "app-review": {
    description: "Tracks app feedback on web / mobile",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  banner: {
    description: "Generic event that Track banner actions on web / mobile",
    ownedBy: ["Core Team" /* Core */]
  },
  "color-selected": {
    description: "Tracks color selected by user on color picker on mobile",
    ownedBy: ["Core Team" /* Core */]
  },
  "create-guest-account": {
    description: "Tracks create guest account for mobile via api / web",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "csv-export": {
    description: "Track csv exports on web / mobile",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "doc-limit-banner": {
    description: "Tracks doc limit warning banner actions on web / mobile",
    ownedBy: ["Growth Team" /* Growth */]
  },
  error: {
    description: "Tracks error on web / mobile",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "estimate-to-invoice": {
    description: "Tracks converting estimate to invoice on web / mobile, not dependant on subscription",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "expense-action": {
    description: "Tracks adding, editing and deleting an expense on web / mobile",
    ownedBy: ["Core Team" /* Core */]
  },
  "free-trial": {
    description: "Tracks free trial banner and trial features clicks",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "free-trial-features-completed": {
    description: "Tracks free trial key features as the user completes them through either demo or organic encounter tours",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "free-trial-start": {
    description: "Tracks free trial start",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "free-trial-tour": {
    description: "Tracks free trial invoice tour",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "invoice-complete": {
    description: `Triggers when an invoice meets the requirements to be completed on web / mobile.
      Currently it only triggers on the first invoice completed on mobile and every invoice completed on web.
      Going forward it should be triggered for every invoice completed for web AND mobile`,
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "invoice-create": {
    description: `Triggers when a document (invoice or estimate or receipt) is first created on web / mobile.
      This event is fired whether or not the invoice is completed. The user can start an invoice and back out and will
      still trigger invoice-create even if they cancel the creation after.`,
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "invoice-email": {
    description: `Tracks when user requests to send an email on web / mobile. Captured each time an invoice is shared via email.
    Can be utilized along with 'msg' table to derive Invoice details which are shared through remote_id.
    On web, the invoiceID is included within the "invoice" field.`,
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "invoice-item-remove": {
    description: "Tracks removing an invoice item on web / mobile",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "invoice-photo": {
    description: "Tracks adding/updating/deleting invoice photos on web / mobile",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "invoice-print": {
    description: "Tracks when user prints an invoice on web / mobile",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "invoice-signature-save": {
    description: "Tracks when an invoice signature is saved on web / mobile",
    ownedBy: ["Core Team" /* Core */]
  },
  "invoice-to-estimate": {
    description: "Tracks converting invoice to estimate on web / mobile",
    ownedBy: ["Core Team" /* Core */]
  },
  "is-paywall": {
    description: "Tracks new paywall events",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "item-create": {
    description: "Tracks creating an item on web / mobile",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "item-delete": {
    description: "Tracks deleting an item on web / mobile",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "item-update": {
    description: "Tracks updating an item on web / mobile",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  logout: {
    description: "Sent on api to track logout for web / mobile",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "onboarding-finish": {
    description: 'Triggered before subscription on mobile app when user finishes onboarding by hitting "Finish" on the last onboarding screen.',
    ownedBy: ["Growth Team" /* Growth */]
  },
  "onboarding-start": {
    description: "Triggered before subscription on mobile app when user starts onboarding.",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "onboarding-step": {
    description: "Triggered when user moves to next onboarding step or goes back to previous step",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "prospect-reactivation": {
    description: 'Triggered on reactivation modal "shown" and "cta clicked" (subscribe now) when a churned user comes back online on web / mobile.',
    ownedBy: ["Growth Team" /* Growth */]
  },
  "save-review-link": {
    description: "Tracks when review link is saved on web / mobile",
    ownedBy: ["Growth Team" /* Growth */]
  },
  signup: {
    description: "Tracks user signup on web. Api tracks signup for mobile",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "subscription-cancel": {
    description: `Triggered when user clicks cancel subscription on web / mobile settings.`,
    ownedBy: ["Growth Team" /* Growth */]
  },
  "subscription-checkout": {
    description: `Triggered before redirecting the user to Stripe Checkout for a new subscription purchase on web.
       Triggers on mobile when user decides to checkout at paywall.`,
    ownedBy: ["Growth Team" /* Growth */]
  },
  "subscription-paywall": {
    description: `Triggered when user lands on paywall on web / mobile.
       When the user is done with the free invoices (mobile: while sending 3rd invoice,
       Web:while sending 1st invoice) and each time the subscription ends.`,
    ownedBy: ["Growth Team" /* Growth */]
  },
  "subscription-switch": {
    description: "Tracks when a user switches subscription on web / mobile",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "surcharge-turned-on": {
    description: "Tracks when user turns on surcharge on web / mobile",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "template-selected": {
    description: "Tracks user chooses a template from the Invoice Templates list on mobile",
    ownedBy: ["Core Team" /* Core */]
  },
  "toggle-request-review": {
    description: "Tracks request review toggle on mobile",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "user-signature": {
    description: "Tracks user signature on web / mobile",
    ownedBy: ["Core Team" /* Core */]
  },
  "validation-error": {
    description: "Tracks validation errors on server / web / mobile",
    ownedBy: ["Core Team" /* Core */]
  },
  warning: {
    description: "Tracks app warning on web / mobile",
    ownedBy: ["Unassigned" /* Unassigned */]
  }
};

// src/events/event-types/descriptions/paypal-event-descriptions.ts
var paypalMultiPlatformEventDescriptions = {
  "payments-screen": {
    description: "Tracks when the user performs actions on payments screens on web / mobile",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  }
};
var paypalServerEventDescriptions = {
  "paypal-checkout-expandClicked": {
    description: '[Checkout] Occurs when the user clicks the expand button on the checkout to see the details of the invoice. This button is visible only on the responsive version, and usually says "View invoice and more info".',
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-checkout-orderCaptureAfter": {
    description: "[Checkout] During checkout, the event occurs after the user tries to pay an order (invoice), we request paypal to check if the payment was successful or not. This event occurs after we request PayPal.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-checkout-orderCaptureBefore": {
    description: "[Checkout] During checkout, the event occurs after the user tries to pay an order (invoice), we request paypal to check if the payment was successful or not. This event occurs before we request PayPal.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-checkout-orderCreateAfter": {
    description: "[Checkout] Occurs when the order creation operation ends during checkout. This is when the user clicks on any of the payment buttons to pay and an order is created.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-checkout-orderCreateBefore": {
    description: "[Checkout] Occurs when the order creation operation begins during checkout. This is when the user clicks on any of the payment buttons to pay and an order is created.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-checkout-paypalButtonClicked": {
    description: "[Checkout] Occurs when the PayPal checkout button is clicked. This occurs after the paypal-checkout-orderCreate events.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-checkout-paypalModalClosed": {
    description: "[Checkout] Occurs when the PayPal pop-up message is closed on the checkout.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-checkout-ready": {
    description: "[Checkout] Occurs when the checkout page is completely loaded.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-checkout-requested": {
    description: "[Checkout] Occurs when the checkout is requested, this is the first event reported (from the backend) on a checkout interaction.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-checkout-viewInvoiceClicked": {
    description: "[Checkout] Occurs whenever the View Invoice button is clicked within the PayPal checkout.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-checkout-viewed": {
    description: "[Checkout] Occurs on the checkout when invoice is payable and the checkout is going to be rendered (from the backend).",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-edge-cases": {
    description: "[Misc] For tracking our workaround of PayPal bugs",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-email": {
    description: "[Misc] Event for tracking payment-related emails sending from IS to users (and to track interactions with the email)",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-landingPage-opened": {
    description: "[Onboarding] Occurs when some of the PayPal landing pages is opened and the user is eligible to see it. Pending, Closed, Accepting, Onboarded and Initial landing pages are available.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-landingPage-viewed": {
    description: "[Onboarding] Occurs when the initial PayPal landing page is viewed. The event paypal-landingPage-opened occurs before this event has been fired.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-merchant-created": {
    description: "[Onboarding] Indicates when a PayPal account is created on the backend.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-merchant-emailConfirmed": {
    description: "[Onboarding] Indicates when the email for the PayPal account has been confirmed.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-merchant-initiatedOnboarding": {
    description: "[Onboarding] This event triggers a webhook when the user starts the onboarding, this webhook has some information about the paypal account, like if the user's email is confirmed or not. This event is tracked just to know if the account is new on paypal (email not confirmed) or the account already exists on paypal (email confirmed).",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-merchant-startedAccepting": {
    description: "[Onboarding] Indicates that a user completed the onboarding and payments are enabled at account level. This means the user is ready to process PayPal payments. Set up to accept payments but does not mean they have processed a payment.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-merchant-startedOnboarding": {
    description: "[Onboarding] Occurs when the user is redirected to PayPal to start the onboarding. This is different from paypal-merchant-initiatedOnboarding which is a tracking event.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-merchant-stoppedAccepting": {
    description: "[Onboarding] Indicates that a merchant has stopped accepting PayPal as a form of payment. This can happen due to compliance issues on PayPal side, the user disabled payments or removed scopes on their PayPal account.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-order-captureSuccess": {
    description: "[Checkout] Indicates when PayPal transaction succeeds.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-paymentSuccess-ctaClicked": {
    description: '[Checkout] Occurs when CTA button is clicked after client has paid invoice on the payment success page. This button is usually the "Try it for free" button urging the client to try InvoiceSimple. This event fires after paypal-paymentSuccess-shown occurs.',
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-paymentSuccess-shown": {
    description: "[Checkout] Occurs when the payment success page is shown after an invoice has been paid. Two related events paypal-paymentSuccess-ctaClicked and paypal-paymentSuccess-viewInvoiceClicked may occur after this one.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-paymentSuccess-viewInvoiceClicked": {
    description: "[Checkout] Occurs when the View Invoice button is clicked after successful PayPal checkout by client on the payment success page. This click allows the user to view the invoice. The event paypal-paymentSuccess-shown occurs before this event.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-pnSuccessfulPayment-sent": {
    description: "[Checkout] Triggered when we send a push notification to notify user of a successful payment. Currently, the notification is in the form of: ${amountPaid} received! ${clientName} paid ${universalInvoice.invoiceNo}",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-seller-consentGranted": {
    description: "[Onboarding] When the user is onboarding on PayPal side, one of the last steps is to give us permissions to process payments on their behalf. When the user grants this permission, paypal triggers a webhook. The event occurs when we receive this webhook.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-seller-emailConfirmed": {
    description: "[Onboarding] This event occurs when we receive the webhook after the user confirms their PayPal email. The webhook is not triggered always and paypal-merchant-emailConfirmed is triggered when we detect the user confirmed the email.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-seller-onboardingInitiated": {
    description: "[Onboarding] This event occurs when PayPal triggers a webhook when the user starts the onboarding, this webhook has some information about the paypal account, like if the user's email is confirmed or not. This event is tracked just to know if the account is new on paypal (email not confirmed) or the account already exists on paypal (email confirmed). PayPal webhooks are not 100% reliable, thats the reason why paypal-merchant-initiatedOnboarding would be more reliable",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  }
};
var paypalWebEventDescriptions = {
  ...paypalMultiPlatformEventDescriptions,
  "payment-modal-viewed": {
    description: "Occurs when a in-app message or pop-up which appears over the screen is viewed by the user.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "payments-disable": {
    description: 'The toggle for "Accepting Payments" on an invoice level is set to "Off".',
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "payments-enable": {
    description: 'The toggle for "Accepting Payments" on an invoice level is set to "On".',
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "payments-initial-cta-shown": {
    description: "Tracks when the initial state component is shown on the webapp, initial state means that the user is eligible for payments but has not started onboarding yet.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "payments-onboarding-continue": {
    description: "Occurs when the user has already started and is continuing the PayPal onboarding process on the webapp.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "payments-onboarding-start": {
    description: "Occurs when PayPal onboarding starts on the webapp. It is the same as payments-merchant-onboardingStart event, but reported from a different source.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "payments-static-learn-more-viewed": {
    description: "Occurs when CTA (button/toggle) is clicked. After that the user will be redirected to learn-more (landing page). These CTAs are inside paypal promotion box on the side bar of web-app.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "payments-static-onboarding-viewed": {
    description: "Occurs when a CTA (button/toggle) is clicked. After that the user will be redirected to paypal onboarding page. These CTAs are inside paypal promotion box on the side bar of web-app.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "payments-webDepositDisabled-shown": {
    description: "Occurs when the deposit feature within an invoice is disabled. This is part of an A/B test.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "payments-webDepositEmail-sent": {
    description: "Occurs when an email is sent to the client to pay the deposit on the invoice.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "payments-webDepositEnabled-shown": {
    description: "Occurs when the deposit feature within an invoice is enabled. This is part of an A/B test.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "payments-webDepositRate-updated": {
    description: "Occurs when the deposit rate is updated/ changed on an invoice.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-invoice-passingFeesClicked": {
    description: "Occurs when the passing fees button/toggle is pressed. This will allow the merchant to pass fees onto their users. The event paypal-invoice-passingFeesShown occurs before this event.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-invoice-passingFeesShown": {
    description: "Occurs when the passing fees button/toggle is shown. This will allow the merchant to pass fees onto their users. The event paypal-invoice-passingFeesClicked may occur after this event occurs.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-navItem-clicked": {
    description: "Occurs when the Items icon is clicked within the payments section of the Navigation of the web app.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  }
};
var paypalMobileEventDescriptions = {
  ...paypalMultiPlatformEventDescriptions,
  "payments-depositDisabled-shown": {
    description: "Tracks when the user or invoice are not eligible for deposits and deposits component is shown but inviting the user to enable payments to request a deposit on the invoice on the mobile app",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "payments-depositEmail-sent": {
    description: "Tracks when the user sends the invoice and it includes a deposit on the mobile app",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "payments-depositEnabled-shown": {
    description: "Tracks when the user and invoice are eligible for deposits and deposits component is shown on the invoice editor of the mobile app",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "payments-depositRate-updated": {
    description: "Tracks when the user updates the deposit rate on the mobile app",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-deeplink-manageaccount-open": {
    description: "Tracks when the user wants to start paypal onboarding and go to the landing page from a deeplink of the mobile app",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-deeplink-paypalonboarding-open": {
    description: "Occurs when the user triggered some action from an external source/ link (like intercom campaign or email). The deeplink will take the user to a certain screen on the mobile app, thereby triggering the browser to start the onboarding process.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-estimate-paymentSetting-pressed": {
    description: "Occurs when the payment setting component on the estimates screen is clicked. The user has already onboarded to payments prior to this event occuring.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-globalNavPayments-clicked": {
    description: "Occurs when the Payments icon is clicked within the payments section of the Global Nav.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-instructions-paymentSetting-pressed": {
    description: "Occurs when the instructions within the Settings icon within PayPal in IS is pressed.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-invoice-payment-toggled": {
    description: "The toggle changes the paymentSuppressed field on the invoice. It means that the user disabled/enabled payments on a particular invoice by clicking on the toggle.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-invoice-paymentSetting-pressed": {
    description: "Occurs when the Setting button within the invoice is pressed within PayPal.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-invoicePassingFees-pressed": {
    description: "Occurs when the Passing Fees button is pressed on an invoice. This allows the user to pass transaction fees onto the user.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-invoicePassingFees-viewed": {
    description: "Occurs when the user views the passing fees feature on the invoice.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-manageAccount-clicked": {
    description: "Occurs when the Manage Account button is clicked within the PayPal section of the app.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-rating-shown": {
    description: "Occurs when a modal asking the customer how they would rate their payments experience.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-settingNavItems-clicked": {
    description: "There is a payments global nav abtest, depending on the abtest variant, the Items link on settings screen is shown. This event tracks when this link is clicked.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-settingsItem-shown": {
    description: "Tracks when the component on the mobile app shows the users the paypal status and the toggle to enable/disable payments.",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "paypal-settingsList-toggleSwitchedOn": {
    description: "Tracks when the payments toggle is switched to enable/disable payments on the mobile app",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  }
};

// src/events/event-types/descriptions/mobile-event-descriptions.ts
var mobileEventDescriptions = {
  ...multiPlatformEventDescriptions,
  ...paypalMobileEventDescriptions,
  "app-loaded": {
    description: "Triggers when mobile loads, ignored on Amplitude",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "app-settings": {
    description: "Triggers when SettingsScreenComponent mounts on mobile, ignored on Amplitude",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "app-welcome": {
    description: "Triggers when WelcomeScreenComponent mounts on mobile, ignored on Amplitude",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "appstore-rate": {
    description: "Tracks when user rates app on app store on mobile",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "backup-uploaded": {
    description: "Tracks when backup is uploaded on mobile",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "dump-uploaded": {
    description: "Tracks upload of app state dump on mobile",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "email-change": {
    description: "Tracks email change on mobile",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "get-started": {
    description: `Triggered on mobile app when first loading and clicking the "Get Started" button. 
      Triggers right before onboarding-start, before subscription`,
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "happiness-rating": {
    description: "Tracks happiness rating on mobile",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "happiness-rating-canceled": {
    description: "Tracks happiness rating dismissed on mobile",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "happiness-rating-displayed": {
    description: "Tracks happiness rating dialogue being displayed on mobile",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "invoice-complete2": {
    description: `Triggers for the second time an invoice meets the requirements to be completed.last seen on 2021-02-26 on web.
    Soon to be deprecated in favor of firing invoice-complete for every invoice`,
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "invoice-get-link": {
    description: `Tracks when when user taps "get link" for an invoice/estimate on mobile`,
    ownedBy: ["Growth Team" /* Growth */]
  },
  "invoice-notification-tap": {
    description: "Tracks invoice notifications tap on mobile",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "invoice-onboarding-fill-client": {
    description: "Tracks when client is filled on onboarding invoice on mobile",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "invoice-onboarding-fill-item": {
    description: "Tracks when item is filled on onboarding invoice on mobile",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "invoice-onboarding-finish": {
    description: "Trakcs when invoice onboarding is completed on mobile",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "invoice-onboarding-skip": {
    description: "Tracks when invoice onboarding is skipped on mobile",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "invoice-onboarding-start": {
    description: "Triggers before subscription on the mobile app when the invoice onboarding starts (component is loaded)",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "invoice-payments-migrated": {
    description: "Track fixing of invoice payments on iOS",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "invoice-share": {
    description: "Tracks invoice sharing on mobile",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "invoice-sms": {
    description: "Tracks sharing invoice by sms on mobile",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "mobile-button-tap": {
    description: "Tracks mobile button tap",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "mobile-color-customization": {
    description: "Tracks mobile color customization",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "mobile-link-tap": {
    description: "Track mobile link tap",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "mobile-modal-view": {
    description: "Tracks mobile modal view",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "mobile-nav-tap": {
    description: "Tracks mobile navigation tap",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "mobile-screen-view": {
    description: "Tracks mobile screen view",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "mobile-tab-tap": {
    description: "Tracks mobile tab tap",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "onboarding-finish-invoice": {
    description: `Triggered on mobile app when user finishes onboarding by hitting the \u201Ccreate invoice\u201D cta.
    Triggers before subscription. If they do not click "Create Invoice" the event onboarding-finish is 
    triggered instead. This event is used to track that the user finished the onboarding process by creating an invoice`,
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "onboarding-invalid": {
    description: "Tracks when onboarding info is not valid on mobile",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "onboarding-v2-details": {
    description: 'Triggered on mobile app when a user finishes the onboarding details screen by hitting "Continue" on the screen.',
    ownedBy: ["Growth Team" /* Growth */]
  },
  "onboarding-v2-finish": {
    description: "Triggered on mobile app when a user finishes the onboarding.",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "onboarding-v2-logo": {
    description: 'Triggered on mobile app when a user finishes the onboarding logo screen by hitting "Continue" on the screen.',
    ownedBy: ["Growth Team" /* Growth */]
  },
  "onboarding-v2-payments": {
    description: 'Triggered on mobile app when a user finishes the onboarding payments screen by hitting "Set Up Online Payments" on the screen.',
    ownedBy: ["Growth Team" /* Growth */]
  },
  "onboarding-v2-revenue": {
    description: 'Triggered on mobile app when a user finishes the onboarding revenue screen by hitting "Continue" on the screen.',
    ownedBy: ["Growth Team" /* Growth */]
  },
  "onboarding-v2-size": {
    description: 'Triggered on mobile app when a user finishes the onboarding size screen by hitting "Continue" on the screen.',
    ownedBy: ["Growth Team" /* Growth */]
  },
  "onboarding-v2-start": {
    description: "Triggered on mobile app when a user starts the onboarding after signing up.",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "onboarding-v2-template": {
    description: 'Triggered on mobile app when a user finishes the onboarding template screen by hitting "Continue" on the screen.',
    ownedBy: ["Growth Team" /* Growth */]
  },
  "onboarding-v2-welcome": {
    description: "Triggered on mobile app when a user sees the onboarding welcome screen.",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "phone-change": {
    description: "Tracks changing phone number in settings on mobile",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "push-received": {
    description: "Tracks push notifications on mobile",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "refer-earn-view": {
    description: "Tracks refer and earn view on mobile",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "reorder-items-doneButtonClicked": {
    description: "Tracks items reordering done botton clicked on mobile",
    ownedBy: ["Core Team" /* Core */]
  },
  "reorder-items-itemReordered": {
    description: "Tracks items reordered and saved on mobile",
    ownedBy: ["Core Team" /* Core */]
  },
  "reorder-items-reorderButtonClicked": {
    description: "Tracks items reorder button clicked on mobile",
    ownedBy: ["Core Team" /* Core */]
  },
  "screen-change": {
    description: "Tracks screen changes and keystrokes on mobile",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "send-reminder-button-clicked": {
    description: "Tracks send invoice reminder button clicked on mobile",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "settings-updated": {
    description: `Specific settings were updated (field renamed, or locale updated). Event is Not dependant on subscription
      Triggered/captured when any property in the setting page is modified. Can be used to see traction on Users who update settings
      to see patterns on often used/changed settings like 'Hide Disable Quantity' on preview page `,
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "sms-consent": {
    description: "Tracks sms consent on mobile",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "statement-share": {
    description: "Tracks sharing Client statements by pdf on mobile",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "sync-end": {
    description: "Tracks server -> local sync end on mobile",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "sync-start": {
    description: "Tracks server -> local sync start on mobile",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "timed-operation": {
    description: "Tracks timed operations such as upload and export actions on mobile",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "version-history-modal": {
    description: "Tracks version history modal on mobile",
    ownedBy: ["Core Team" /* Core */]
  },
  "web-only-carousel-shown": {
    description: "Tracks web only carousel shown on mobile",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  webview: {
    description: "Tracks webview actions on mobile",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "welcome-back": {
    description: "Tracks welcome back screen on mobile",
    ownedBy: ["Unassigned" /* Unassigned */]
  }
};

// src/events/event-types/descriptions/server-event-descriptions.ts
var serverEventsDescriptions = {
  ...paymentsSeverEventDescriptions,
  ...paypalServerEventDescriptions,
  "advocate-friend-action": {
    description: "Tracks advocate friend action",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "advocate-reward": {
    description: "Tracks advocate reward for successfully referred friend",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "advocate-reward-rejected": {
    description: "Tracks advocate reward rejection",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "app-install": {
    description: "Tracks new app installation for web via api",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "app-start": {
    description: "Tracks app start for mobile via api",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "app-update": {
    description: "Tracks new app installation for web via api",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "create-guest-account": multiPlatformEventDescriptions["create-guest-account"],
  "disputed-chargebee-sub-canceled": {
    description: "Tracks Chargebee sub cancellation dispute on api",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "edge-webhook": {
    description: "Tracks webhook events from Edge",
    ownedBy: ["Core Team" /* Core */]
  },
  error: multiPlatformEventDescriptions.error,
  "expense-ocr-data": {
    description: "The OCR webhook response",
    ownedBy: ["Core Team" /* Core */]
  },
  "free-trial-limit": {
    description: "Tracks free trial limits",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "installation-token-changed": {
    description: "Tracks mobile installation token changed via api",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "invoice-send": {
    description: "Tracks invoice sent on email for mobile via api",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "itunes-cancel-required": {
    description: "Tracks iTunes cancellation required before sub upgrade via api",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  login: {
    description: "Sent on api to track login for web / mobile",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "mailgun-supression-cleared": {
    description: "Tracks Mailgun suppressions cleared for an email on api",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "notification-triggered-failed-payment": {
    description: "Tracks payment failed notification triggered on mobile via api",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "password-reset-request": {
    description: "Tracks password reset request for web / mobile via api",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "password-reset-success": {
    description: "Tracks password reset success for web / mobile via api",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "payment-reminder-email-send": {
    description: "Tracks payment reminder email sent via api",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "purchase-predicted-1d": {
    description: "Tracks purchase predicted daily on a scheduled job",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "show-upgrade-paywall": {
    description: "Tracks rendering of upgrade paywall for web via api",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  signup: multiPlatformEventDescriptions.signup,
  "stripe-activate": {
    description: "Tracks stripe activation via api",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "stripe-charge": {
    description: "Tracks stripe charge via api",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "stripe-charge-failed": {
    description: "Tracks stripe charge failed via api",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "stripe-charge-refunded": {
    description: "",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "stripe-charges-disabled": {
    description: "",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "stripe-payout": {
    description: "",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "stripe-payouts-disabled": {
    description: "",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "subscription-add-payment-src": {
    description: "",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "subscription-cancelled": {
    description: "Tracks when a subscription cancel request is received. The subscription will expire at the end of the billing cycle.",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "subscription-move": {
    description: "",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "subscription-purchase": {
    description: "",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "subscription-reactivated": {
    description: "",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "subscription-renewal": {
    description: "Tracks all subscription renewals (web, ios, and android)",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "subscription-switch": {
    description: "Tracks a subscription change when using a coupon on iOS",
    ownedBy: ["Core Team" /* Core */]
  },
  "subscription-trial-extend": {
    description: "",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "subscription-trial-start": {
    description: "",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "sync-mismatch": {
    description: "",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  unifiedxp: {
    description: "Track all the interaction related to unified experience, handled by is-unifiedxp",
    ownedBy: ["Payments Core Team" /* PaymentsCore */]
  },
  "version-history": {
    description: "Tracks version history server events",
    ownedBy: ["Core Team" /* Core */]
  }
};

// src/events/event-types/descriptions/web-event-descriptions.ts
var webEventDescriptions = {
  ...paymentsWebEventDescriptions,
  ...multiPlatformEventDescriptions,
  ...paypalWebEventDescriptions,
  "acknowledgement-modal-shown": {
    description: "Triggers on web when the Terms of Service acknowledge modal is shown. Also captures creation of guest account on web.",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "app-load": {
    description: "Triggers on web vitals, ignored on Amplitude",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "app-paint": {
    description: "Ignored on Amplitude",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "app-ready": {
    description: "Tracks on web when the app is ready, ignored on Amplitude",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "app-req": {
    description: "Tracks on web when server receives a request, ignored on Amplitude",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "chrome-ext-visit": {
    description: "Tracks chrome extension visit on web",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "client-autosave-tooltip-clicked": {
    description: "Tracks client autosave tooltip clicked on web invoice editor",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "client-signature-complete": {
    description: "Tracks when an estimate is signed by a client on web public invoice",
    ownedBy: ["Core Team" /* Core */]
  },
  "connectivity-alert": {
    description: "Tracks connectivity error on web",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "estimate-list-view": {
    description: "Tracks when estimate list view loads on web",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  identify: {
    description: "Identifies user (used in Amplitude). Critical from a technical perspective because it ensures that Amplitude User properties are up to date.",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "instant-form-preview-email": {
    description: "Tracks instant form preview email on web",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "instant-form-print": {
    description: "Tracks printing document on web instant form",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "instant-form-public-link": {
    description: "Tracks instant form public link on web",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "invoice-download": {
    description: `Triggers when a user downloads the invoice as PDF on web invoice editor. 
       Can be used to track shared invoices along with invoice-email, invoice-sms, and invoice-print.`,
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "invoice-edit-nav": {
    description: "Tracks when navigating to invoice edit form on web",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "invoice-email-cancel": {
    description: "Tracks when user cancels sending an invoie by email on web",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "invoice-email-error": {
    description: "Tracks invoice emailing error on web",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "invoice-email-nav": {
    description: "Tracks navigation to invoice email form on web",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "invoice-email-send": {
    description: "Tracks sending an invoice by email on web",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "invoice-email-sent": {
    description: "Triggers on the web app when the user sends an invoice email and the result is successful. Only fires for subscribers",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "invoice-email-view": {
    description: "Tracks when invoice email view loads on web",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "invoice-item-add": {
    description: "Tracks adding an invoice item on web",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "invoice-link": {
    description: "Tracks opening public invoice link on web",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "invoice-list-view": {
    description: "Tracks when invoice list view loads on web",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "invoice-payment-cancel": {
    description: "Tracks invoice payment cancellation on web",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "invoice-payment-nav": {
    description: "Tracks navigation to invoice payment on web",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "invoice-payment-save": {
    description: "Tracks saving payment of invoice on web",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "invoice-payment-view": {
    description: "Tracks when invoice payment component loads on web",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "invoice-photo-add-attempted": {
    description: "Tracks attempt to add invoice photo on web",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "invoice-preview-nav": {
    description: "Tracks navigation to invoice preview on web",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "invoice-set-field": {
    description: "Tracks when invoice field is set on web",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "login-view": {
    description: "Tracks when Login component mounts on web",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "notification-permission-response": {
    description: "Tracks whether notification permission has been granted on web",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "notification-prompt-response": {
    description: "Tracks whether notification install prompt permission has been accepted on web",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "notification-prompt-shown": {
    description: "Tracks when NotificationPrompt component mounts on web",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "pagination-click": {
    description: "Tracks invoices / clients / items pagination on web",
    ownedBy: ["Core Team" /* Core */]
  },
  "password-reset": {
    description: "Tracks successful password reset on web",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "password-reset-attempt": {
    description: "Tracks user not found when attempting to reset password on web",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "payment-reminder-email-send": {
    description: "Tracks when user sends a payment reminder email on web",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "public-invoice-view": {
    description: "Tracks public invoice view on web",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  recaptcha: {
    description: "Tracks recaptcha events on web",
    ownedBy: ["Core Team" /* Core */]
  },
  "referral-action": {
    description: "Tracks referral actions (e.g. landing-page-viewed, email-entered, signed-up) on web",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "report-list-view": {
    description: "Tracks when user report list view loads on web",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "review-link-clicked": {
    description: "Tracks when user clicks review link on web",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "save-default-theme": {
    description: "Tracks saving default theme on web",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "self-email-preview-send-clicked": {
    description: "Tracks when user sends preview to self on web",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "send-reminder-button-clicked": {
    description: "Tracks when user clicks the send payment reminder button on web",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "setting-list-view": {
    description: "Tracks when setting list view loads on web",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "setting-set-field": {
    description: "Tracks when user changes a setting field on web",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "signup-view": {
    description: "Tracks when Signup component mounts on web",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "sms-checkout": {
    description: "Tracks Stripe SMS checkout on web",
    ownedBy: ["Unassigned" /* Unassigned */]
  },
  "subscription-cancel-applyDiscountButtonClicked": {
    description: "Tracks apply discount button clicked during exit page workflow on web",
    ownedBy: ["Core Team" /* Core */]
  },
  "subscription-cancel-cancelAnywayButtonClicked": {
    description: "Tracks cancel anyway button clicked during exit page workflow on web",
    ownedBy: ["Core Team" /* Core */]
  },
  "subscription-cancel-pageViewed": {
    description: "Tracks subscription cancel pages viewed on web",
    ownedBy: ["Core Team" /* Core */]
  },
  "subscription-cancel-returnToAppButtonClicked": {
    description: "Tracks return to app button clicked during exit page workflow on web",
    ownedBy: ["Core Team" /* Core */]
  },
  "subscription-purchase-invoices": {
    description: "Tracks when user lands on the invoice list after successful Stripe Checkout purchase",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "subscription-purchase-login": {
    description: "Tracks when user lands on the login page after successful Stripe Checkout purchase",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "subscription-purchase-signup": {
    description: "Tracks when user lands on the signup page after successful Stripe Checkout purchase",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "subscription-view": {
    description: "Triggered when user visits the paywall route: `/subscription` on web.",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "subscription-view-free": {
    description: "Tracks when SubscriptionFree component mounts on web",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "subscription-view-trial": {
    description: "Tracks when SubscriptionTrial component mounts on web",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "upgrade-web-mobile": {
    description: " Triggered when user successfully upgrades to premium/web+mobile from the upgrade to premium page: `/upgrade` on web",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "upgrade-web-mobile-paywall": {
    description: "Triggered when user lands on the premium upgrade page: `/upgrade`on web",
    ownedBy: ["Growth Team" /* Growth */]
  },
  "web-button-click": {
    description: "Tracks on web when user clicks on a button",
    ownedBy: ["Core Team" /* Core */]
  },
  "web-link-click": {
    description: "Tracks on web when user clicks on a link",
    ownedBy: ["Core Team" /* Core */]
  },
  "web-modal-view": {
    description: "Tracks on web when user clicks on a modal",
    ownedBy: ["Core Team" /* Core */]
  },
  "web-nav-click": {
    description: "Tracks on web when user navigates to a page",
    ownedBy: ["Core Team" /* Core */]
  },
  "web-page-view": {
    description: "Tracks on web when user clicks on a page",
    ownedBy: ["Core Team" /* Core */]
  },
  "web-search": {
    description: "Tracks usage of search functionality of Documents / Clients / Items on web",
    ownedBy: ["Core Team" /* Core */]
  },
  "web-tab-click": {
    description: "Tracks on web when user clicks on a tab",
    ownedBy: ["Core Team" /* Core */]
  },
  "welcome-banner-dismiss": {
    description: "Tracks welcome banner dismissed on web",
    ownedBy: ["Growth Team" /* Growth */]
  }
};

// src/events/event-types/descriptions/index.ts
var eventDescriptions = {
  ...mobileEventDescriptions,
  ...webEventDescriptions,
  ...serverEventsDescriptions,
  ...brazeCustomEventDescriptions
};

// src/events/meta/meta-descriptions.ts
var paymentsMetaPropertiesDescriptions = {
  activePaymentProvider: "payment provider user's action is linked ex) PayPal, Stripe",
  actor: "Role of the user",
  amountPaid: "Amount paid",
  "application-id": "Application ID for financing",
  browserName: "Browser name",
  browserVersion: "Browser version",
  clientName: "Client name",
  component: "component where user action occurred",
  ctaName: "Name of the CTA",
  ctaType: "Type of the CTA",
  ctaValue: "Value of the CTA",
  currencyMismatch: "True if currency mismatch",
  depositAmount: "Deposit amount",
  depositRate: "Deposit rate",
  depositValue: "Deposit value",
  deviceModel: "Device model",
  deviceType: "Device type",
  deviceVendor: "Device vendor",
  eligibility: "User eligibility",
  eligiblePaymentProviders: "eligible payment providers ex) PayPal, Stripe",
  emailVerified: "True if email is verified. applicable only paypal",
  email_confirmed: "True if the email is confirmed",
  feature: "Name of the feature that triggered the event",
  fundingSource: "Payment funding source",
  invoiceNumItems: "Number of items of the Invoice",
  invoiceTotal: "Invoice total amount",
  invoiceTotalMutated: "Invoice total after mutation",
  isEligibleForBillingDetailsCheckout: "True if the request is eligible for billing details checkout experiment",
  isEligibleForPF: "True if user and invoice are eligible for passing fees feature",
  isPPCPCheckout: "True if the checkout is a PPCP checkout",
  isPriceTransparencyShown: "True if user is eligible to see price transparency experiment",
  isProgressiveOnboardingOrder: "True is the order is Progressive Onboarding",
  location: "Event location",
  merchantId: "User ID on PayPal",
  onboardingStatus: "Onboarding status",
  origin: "Component that originates the request",
  originalAmount: "Original amount",
  originalRate: "Original rate",
  osName: "OS name",
  osVersion: "OS version",
  paymentError: "Payment error",
  paymentMethod: "Payment method",
  paymentStatus: "Payment status",
  paymentsHolder: "Component holding the feature",
  paypalStatus: "PayPal user status",
  previousProducts: "PayPal products user were onboarded before",
  "process-status": "Process status of the financing",
  product: "PayPal onboarding product",
  progressiveOnboardingPendingOrders: "Progressive onboarding orders of the user",
  revenue: "Revenue from payments",
  screenAction: "Actions performed on screen",
  securityMessageABTest: "Security message AB test",
  settingsEmail: "email of user set on settings.",
  settingsName: "Name of user set on settings.",
  settingsPhone: "phone number of user set on settings.",
  stripeStatus: "Stripe onboarding status",
  surchargeCents: "Surcharge cents",
  transactionId: "Transaction ID",
  updateSource: "Component that originated the update request",
  updatedAmount: "Updated amount",
  updatedRate: "Updated rate",
  walletType: "Wallet type: Google Pay, Apple Pay, Link"
};
var metaPropertiesDescriptions = {
  ...paymentsMetaPropertiesDescriptions,
  abTests: "Object containing ABTests",
  accepted: "True if permission is accepted",
  account: "Account ID",
  "account-id": "Account ID",
  action: "Generic user action",
  additionalDetails: "Additional details string",
  amount: "Generic amount property",
  annualRevenue: "Annual revenue of the company",
  app: "App identifier",
  "app-host": "App host",
  "auth-provider": "Google or Facebook",
  "available-features": "Free trial available features",
  "back-from": "Onboarding screen navigated back from (introduced in Onboarding V3)",
  billing_period_unit: "Subscription billing period unit",
  brand: "Payment source card brand",
  by: "",
  campaign: "Welcome campaign",
  "cancel-date": "Subscription cancel date",
  category: "Category string",
  changeDate: "Date of subscription change",
  charge: "Stripe charge URL and ID",
  "charge-id": "Charge ID",
  "client-signature": "Client signature (off, unsigned, signed)",
  code: "Generic code property",
  color: "Selected color",
  companyAddressLine1: "",
  companyAddressLine2: "",
  companyAddressLine3: "",
  companyIndustry: "Industry of the company",
  companyIndustryGCID: "GCID of the industry denoting its Google Business Profile category",
  companyName: "Name of the company",
  companySize: "Size of the company",
  "completed-feature": "Free trial completed feature",
  "completed-features": "Free trial completed features",
  "completed-features-total": "Total of free trial completed features",
  "completed-tour-screens": "Number of completed tour screens",
  "consent-granted": "True if consent granted",
  contactEmail: "",
  contactPhone: "",
  count: "Generic count property",
  country: "Generic country property",
  "coupon-sku": "Coupon SKU associated with a subscription",
  currency: "Currency property",
  currencyCode: "Currency code property",
  current: "Generic current property",
  "current-order-id": "Current order ID",
  "current-order-sku": "Current sku string",
  "current-platform": "Current platform",
  "current-price": "Current pricing",
  "custom-color": "True if custom color",
  customer_email: "Subscription customer email",
  customer_id: "Subscription customer ID",
  data: "Sync data",
  dataPulled: "",
  dataPushed: "",
  "days-left": "Days left in free trial",
  description: "Description string",
  "discount-price-usd": "Discounted USD price of a subscription",
  dismissed: "True if PDF dismissed",
  "doc-type": "All(-1) / Invoice(0) / Estimate(1) / Receipt(2)",
  docCount: "Number of invoices and estimates",
  docType: "All(-1) / Invoice(0) / Estimate(1) / Receipt(2)",
  "docs-remaining": "Number of docs user can create",
  docsCountLastMonth: "Number of docs created last month",
  documentId: "Invoice or estimate ID",
  documentType: "Invoice or estimate",
  dst: "Destination account ID",
  dueDate: "due date of the invoice",
  dumpKey: "Dump key string",
  duration: "Duration",
  eligible: "Generic eligible property (boolean)",
  email: "An email address",
  enabled: "True if enabled",
  end: "End timestamp",
  endOfTerm: "Whether subscription term has ended",
  error: "Error message",
  errors: "Onboarding invalid error messages",
  estimateRemoteId: "Remote ID of the Estimate",
  event: "Name of incoming event (from webhooks etc)",
  expired: "Subscription expired timestamp",
  "expiry-date": "Free trial expiry date",
  failure_code: "Stripe charge failed error code",
  failure_message: "Stripe charge failed error message",
  "feature-clicked": "Trial feature name",
  feedback: "Feedback for feature review",
  field: "Invoice settings field that was changed",
  fields: "",
  "file-extension": "",
  from: "Generic from property",
  "from-date": "Start date",
  "from-guest-account": "User has signed up using guest account with or without session",
  full: "True if full sync",
  hasImage: "Yes if the expense has an image",
  hexColor: "Color hex code",
  id: "An ID property",
  "include-images": "True if include images checkbox is checked when exporting expenses CSV",
  interPlatform: "True if trying to switch from a different platforms subscription",
  interval: "Subscription interval - annual, monthly ...",
  invoice: "Document ID",
  "invoice-complete-count": "Number of completed invoices",
  "invoice-count": "Number of invoices",
  "invoice-id": "Document ID",
  "invoice-no": "Document number",
  invoiceId: "Document ID",
  invoiceNo: "Invoice No.",
  invoiceRemoteId: "Remote ID of the Invoice",
  invoiceValue: "Invoice value",
  "is-trial-active": "True if free trial active",
  "is-trial-enabled": "True if free trial enabled",
  isDeposit: "True if deposit",
  isFromEmailValid: "True if from em\xE5ail is valid",
  isToEmailValid: "True if to email is valid",
  is_owner: "True if user is owner of invoice",
  issues: "Sync mismatch issues",
  label: "Generic label property",
  last4: "Payment source last 4 digits",
  limit: "Limit of referrals an advocate can do within a time frame",
  logoUrl: "Logo URL",
  md5: "MD5 hash value",
  merchant: "Merchant Name",
  message: "A generic message property",
  mobile: "Mobile number",
  name: "Generic name property",
  "new-order-sku": "New order sku string",
  "new-price-usd": "New subscription price in USD",
  newPrice: "New price",
  newSku: "New SKU after upgrade",
  newToken: "New installation token",
  newUser: "User ID of new user",
  newVersion: "New app version",
  number: "Number of photos",
  oldSku: "Old SKU before upgrade",
  oldTier: "Old Tier before upgrade",
  oldToken: "Old installation token",
  oldVersion: "Old app version",
  "onboarding-version": "Onboarding version (e.g. v1/v2/v3)",
  openedIn: "What the PDF was opened with",
  "order-id": "Order ID",
  "order-type": "Type of subscription order",
  orderId: "Order ID",
  orderSku: "Order SKU",
  page: "Generic page property",
  path: "Navigation path where action was taken",
  paymentMode: "payment mode",
  paymentValue: "invoice payment value",
  phone: "Phone number",
  photo: "",
  plan_id: "Subscription plan ID",
  plan_unit_price: "Subscription plan unit price",
  platform: "Platform of the app that sent the event",
  prev: "Generic previous property",
  previousUninstalledAtValue: "Date of last app uninstall",
  price: "Current price",
  "push-type": "Type of push notification",
  query: "Generic query property",
  rating: "Generic rating property",
  reason: "Generic reason property",
  recipients: "Number of recipients",
  "referral-code": "Referral code (Friendbuy)",
  "referral-email": "Referral email entered on referral landing page",
  "referral-friend-id": "Referral friend ID",
  "reject-reason": "Reason for advocate reward rejection",
  "remote-id": "Document remote ID",
  remoteId: "Generic remote ID property",
  "request-signature": "Whether an estimate requires a client signature. Only added when doc-type is 1",
  requestId: "Request ID",
  response: "OCR webhook response",
  reviewLink: "Review link URL",
  score: "Generic score property",
  screen: "Tracks navigation screen of app",
  service: "Subscription service and event-triggering service",
  shouldNotTrackIntercom: "Flags the event on mobile to not send to Intercom from backend",
  signDate: "Date when signature is saved",
  signals: "Prediction signals",
  signatureRemoteId: "RemoteId of the signature photo",
  signatureUrl: "URL of the signature photo",
  size: "File size in bytes",
  sku: "Subscription SKU",
  source: "A generic source property",
  source_id: "Payment source ID",
  src: "Source account ID",
  start: "Start timestamp",
  "start-date": "Free trial start date",
  startTime: "Start time",
  "statement-type": "Statement filter options",
  status: "Password reset attempt status",
  step: 'Onboarding step/screen user just completed or "back" when navigating back',
  "store-coupon-sku": "Coupon SKU from App Store / Google Play Store associated with a subscription",
  subscription: "Subscription order ID",
  "subscription-active": "True if subscription is active",
  "subscription-expiry": "Subscription expiry date",
  subscription_id: "Subscription ID",
  subscription_status: "Subscription status",
  syncId: "Sync ID",
  template: "Template Code",
  text: "Extra navigation event details",
  themeColor: "",
  tier: "Sub tier",
  "to-date": "End date",
  token: "Password reset token",
  "total-features": "Total free trial features",
  tour: "Free trial tour type",
  "trial-order-id": "Trial order ID",
  "trial-sku": " Trial SKU",
  trigger: "The path that triggered the event",
  type: "Generic type property",
  upgradeVariant: "Upgrade variant ABTests",
  url: "URL string",
  user: "User ID",
  "user-id": "User ID",
  value: "A generic value property",
  variant: "A generic variant property",
  version: "App version"
};

// src/index.ts
var IsEvents = class {
  constructor(environment, options) {
    this.environment = environment;
    this._baseUrl = (options == null ? void 0 : options.baseUrl) || mkBaseUrl(environment);
    this.eventBridge = new EventBridge(this._baseUrl);
  }
  _baseUrl;
  eventBridge;
  get baseUrl() {
    return this._baseUrl;
  }
  async sendEvent(visitor, event) {
    await this.eventBridge.sendToBus(visitor, event);
  }
  async identify(visitor, abtests) {
    visitor = { ...visitor, extraUserProperties: { ...visitor.extraUserProperties, ...abtests } };
    await this.eventBridge.sendToBus(visitor, {
      id: (0, import_uuid.v1)(),
      meta: {},
      name: "identify",
      timestamp: Date.now()
    });
  }
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  APIDomainNames,
  AfEvents,
  App,
  AppEventPath,
  DeviceType,
  DownstreamSystems,
  ErrorTypes,
  EventOwnedBy,
  EventTrackingPaths,
  OS,
  Platform,
  eventDescriptions,
  eventNameMap,
  metaPropertiesDescriptions,
  oldEventNameMap
});
//# sourceMappingURL=index.js.map
